import { AppConfigProvider } from "../AppConfigProvider";
import { IRemoteOcr } from "./IRemoteOcr";
import { OcrResult } from "./OcrResult";


export class RemoteOcr implements IRemoteOcr
{
    public static Url = 'https://ocr.specteam.pl';

    constructor(private _config: AppConfigProvider)
    { }

    private BlobToJpegFile(blob: Blob): File
    {
        const now = new Date();
        const pad = (n: number) => n.toString().padStart(2, '0');
        const fileName = `${now.getFullYear()}_${pad(now.getMonth() + 1)}_${pad(now.getDate())}__${pad(now.getHours())}_${pad(now.getMinutes())}_${pad(now.getSeconds())}.jpeg`;
        return new File([blob], fileName, { type: 'image/jpeg' });
    }

    public async UploadAndScan(image: Blob): Promise<string | null>
    {
        try
        {
            const jpegFile = this.BlobToJpegFile(image);

            const formData = new FormData();
            formData.append('file', jpegFile);
            formData.append('folder', this._config.Password);

            const fetchResponse = await fetch(RemoteOcr.Url, {
                method: 'POST',
                body: formData
            });

            if (fetchResponse.status !== 200)
            {
                return null;
            }

            const result = await fetchResponse.json() as OcrResult;

            if (result.readResult.blocks.length > 0)
            {
                return result.readResult.blocks[0].lines.map(x => x.text).join("\n");
            }

            return "";
        }
        catch (ex)
        {
            console.error('File upload problem:', ex.message);
            return null;
        }
    }
}
